import { useLanguageStore } from "@/store/languageStore";
import {
  speak,
  pauseSpeaking,
  resumeSpeaking,
  stopSpeaking,
} from "@/utils/speech";
import { useState, useCallback } from "react";

const useMessagePlayer = () => {
  const [currentMessage, setCurrentMessage] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [hasFinished, setHasFinished] = useState(false);
  const selectedVoiceName = useLanguageStore((s) => s.selectedVoiceName);
  const onEnd = (onFinish?: Function) => {
    setIsPlaying(false);
    setHasFinished(true);
    if (onFinish) onFinish();
  };

  const readText = useCallback(
    (
      message: string,
      voiceLang: string,
      voiceOn: boolean,
      options?: { toggleVolume?: boolean; onFinish?: Function }
    ) => {
      const toggleVolume = options?.toggleVolume ?? false;
      const onFinish = options?.onFinish;

      console.log("toggleVolume", toggleVolume);
      console.log("isPlaying", isPlaying);
      if (isPlaying && toggleVolume) {
        stopSpeaking();
        setIsPlaying(false);
      }

      if (isPlaying && !toggleVolume) return;

      // setIsPlaying(true);
      // setIsPaused(false);
      // setHasFinished(false);
      // setCurrentMessage(message);

      if (!toggleVolume || (toggleVolume && voiceOn)) {
        console.log("speak", message);
        speak(
          message,
          voiceLang,
          voiceOn,
          selectedVoiceName,
          () => {
            setIsPlaying(true);
            setIsPaused(false);
            setHasFinished(false);
            setCurrentMessage(message);
          },
          () => onEnd(onFinish), // onError
          () => onEnd(onFinish) //onFinish
        );
      }
    },
    [isPlaying]
  );

  const cancelReading = useCallback(() => {
    stopSpeaking();
    setIsPlaying(false);
    setIsPaused(false);
    setCurrentMessage("");
    setHasFinished(false);
  }, []);

  const pauseReading = useCallback(() => {
    if (isPlaying && !isPaused) {
      pauseSpeaking();
      setIsPaused(true);
      setIsPlaying(false);
    }
  }, [isPlaying, isPaused]);

  const resumeReading = useCallback(() => {
    if (isPlaying && isPaused) {
      resumeSpeaking();
      setIsPaused(false);
      setIsPlaying(true);
    }
  }, [isPlaying, isPaused]);

  return {
    currentMessage,
    isPlaying,
    isPaused,
    hasFinished,
    readText,
    cancelReading,
    pauseReading,
    resumeReading,
  };
};

export default useMessagePlayer;
